import { Paper } from '@mui/material';
import { useCommonStyles } from '../../../Common/Styles';
import React, { useState } from 'react';
import { Order } from '../../../Helpers/Literals';
import { Audit, PortalUser } from './Model/AuditModel';
import AuditHeaderToolbar from './Components/AuditHeaderToolbar';
import { auditService } from './AuditService';
import ShowKeyVaultData from './Components/RenderAuditData';
import { useTranslation } from 'react-i18next';
import { showToast } from '../../../lib/toast';

export default function AuditHome() {
  const { classes } = useCommonStyles();
  const { t } = useTranslation('audit');
  const [order, setOrder] = React.useState<Order>('asc');
  const [orderBy, setOrderBy] = React.useState<keyof Audit>('DateAdded');
  const [page, setPage] = React.useState(1);
  const initialState: Audit[] = [];
  const [auditLogs, setAuditLogs] = React.useState(initialState);
  const [loading, setLoading] = useState(false);
  const pageSize = 40;
  const [excludeAutomationEnties, setExcludeAutomationEnties] = useState(true);
  const [totalAuditsCount, setTotalAuditsCount] = useState(1);
  const initialselectedUsers: PortalUser[] = [];
  const [selectedUsers, setSelectedUsers] =
    React.useState(initialselectedUsers);
  const [Entity, setEntity] = React.useState('');

  React.useEffect(() => {
    loadAuditLogs();
  }, [excludeAutomationEnties, page, Entity, selectedUsers]);

  const loadAuditLogs = async () => {
    let queryString = '';
    queryString = getQuerryString();
    try {
      setLoading(true);
      const auditlogsReceived = await auditService.GetAuditLogs(queryString);
      setTotalAuditsCount(auditlogsReceived.TotalCount);
      setAuditLogs(auditlogsReceived.Items);
      setLoading(false);
    } catch (error) {
      showToast({
        title: t('audit.error.fetchingAuditLogs'),
        type: 'error',
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const appendQuery = (input: string, query: string) => {
    if (input == null || input.length === 0) input += '?';
    else input += '&';

    return input + query;
  };

  const getQuerryString = () => {
    let query = '';
    if (page) {
      query = appendQuery(query, 'page=' + page);
    }
    if (pageSize) {
      query = appendQuery(query, 'pageSize=' + pageSize);
    }
    if (Entity) {
      query = appendQuery(query, 'entity=' + Entity);
    }
    if (selectedUsers.length > 0) {
      query = appendQuery(
        query,
        'performed=' + selectedUsers.map((p) => p.Username).join(';'),
      );
    }
    if (excludeAutomationEnties) {
      query = appendQuery(query, 'excludePerformedBy=automation');
    }
    return query;
  };

  function handleRequestSort(
    event: React.MouseEvent<unknown>,
    property: keyof Audit,
  ) {
    const isDesc = orderBy === property && order === 'desc';
    setOrder(isDesc ? 'asc' : 'desc');
    setOrderBy(property);
  }

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement>,
    value: number,
  ) => {
    setPage(value);
  };

  return (
    <>
      <AuditHeaderToolbar
        loadAuditLogs={loadAuditLogs}
        excludeAutomationEnties={excludeAutomationEnties}
        setExcludeAutomationEnties={setExcludeAutomationEnties}
        selectedUsers={selectedUsers}
        setSelectedUsers={setSelectedUsers}
        Entity={Entity}
        setEntity={setEntity}
      />
      <Paper className={classes.Paper}>
        <ShowKeyVaultData
          AuditList={auditLogs}
          order={order}
          orderBy={orderBy}
          loading={loading}
          totalAuditsCount={totalAuditsCount}
          pageSize={pageSize}
          page={page}
          handleRequestSort={handleRequestSort}
          handlePageChange={handlePageChange}
        />
      </Paper>
    </>
  );
}
